/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnBuilderSendto.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/pnn-builder-sendto";

export class AutogenModelPnnBuilderSendto<RowType extends ModelRow> extends Endpoint<RowType, RowPnnBuilderSendtoFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnBuilderSendto extends ModelRow<RowPnnBuilderSendtoFields> {
	constructor(values?: Partial<RowPnnBuilderSendtoFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnBuilderSendtoFields {
	company_id: string;
	lane_number: string;
	master_id: string;
	master_type: string;
	sendto_detail: string;
	sendto_name: string;
	sendto_via: string;
	sequence: number;
	unsubscribe_date: Date;
}

